import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2025 Seattle Street Bulletin. All original content produced by Seattle Street Bulletin is shared under a Creative Commons Attribution-NonCommercial 4.0 International License. Third-party materials are presented for documentation purposes only and are not republished for commercial gain.</p>
    </footer>
  );
}

export default Footer;